import { DatePicker, Form, InputNumber, Select, Space } from "antd";
import AddingTable from "components/Tables/AddingTable";
import TextArea from "antd/es/input/TextArea";
import { Trans_TYPES } from "../../../constants/accountsConstants";
import WrappingModal from "../../../components/Modals/WrappingModal";
import { useGetProductsQuery } from "../../../redux/Service/productsApi";
import { useGetStoresQuery } from "../../../redux/Service/storesApi";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  subData: any[];
  setSubData: any;
  branches: any[];
  costCenters: any[];
  accDailys: any[];
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  subData,
  setSubData,
  branches,
  costCenters,
  accDailys,
}: Props) => {
  const { data: productsData, isLoading } = useGetProductsQuery(undefined);
  const products = productsData?.ResponseObject ?? [];

  const { data: storiesData, isLoading: isStoriesLoading } =
    useGetStoresQuery(undefined);
  const stories = storiesData?.ResponseObject ?? [];

  const columns = [
    {
      title: "م",
      dataIndex: "RowNo",
      width: 20,
      editable: false,
    },
    {
      title: " المنتج",
      dataIndex: "ProductID",
      // width: 130,
      editable: true,
      inputType: "select",
      options: products.map((producct: any) => ({
        value: String(producct.ProductID),
        label: producct.Productname,
      })),
    },
    {
      title: "السعر",
      dataIndex: "ProductCost",
      // width: 120,
      editable: true,
      inputType: "number",
    },

    {
      title: "مركز التكلفه",
      dataIndex: "CostId",
      // width: 130,
      editable: true,
      inputType: "select",
      // Pass options dynamically from your accounts list:
      options: costCenters.map((center: any) => ({
        value: String(center.CostID),
        label: center.CostName,
      })),
      render: (text: string) => {
        const account = costCenters.find((a: any) => String(a.CostID) === text);
        return account ? account.CostName : text;
      },
    },
    {
      title: "ملاحظات",
      dataIndex: "Notes",
      // width: 200,
      editable: true,
      inputType: "text",
    },
  ];

  const onFinish = (values: any) => {
    handleOk(values);
  };

  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل حركة" : "إضافة حركة"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        {/* Data Entry Section */}
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {isEditing && (
              <Form.Item name="TransDoc" label="كود الحركة">
                <InputNumber
                  placeholder="كود الحركة"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}

            <Form.Item name="BranchId" label="الفرع">
              <Select
                placeholder="الفرع"
                showSearch
                optionFilterProp="children"
                options={branches.map((branch: any) => ({
                  value: branch.BranchID,
                  label: branch.BranchName,
                }))}
                className="w-full"
              />
            </Form.Item>

            <Form.Item name="DocDate" label="تاريخ الحركة">
              <DatePicker
                placeholder="تاريخ الحركة"
                className="w-full"
                format="YYYY-MM-DD"
              />
            </Form.Item>

            <Form.Item name="TransType" label="نوع الحركة">
              <Select
                placeholder="نوع الحركة"
                showSearch
                optionFilterProp="children"
                options={Trans_TYPES.map((bal: any) => ({
                  value: bal.value,
                  label: bal.label,
                }))}
                className="w-full"
              />
            </Form.Item>

            <Form.Item name="StoreId" label="المخزن">
              <Select
                placeholder=""
                showSearch
                optionFilterProp="children"
                options={stories.map((bal: any) => ({
                  value: bal.StoreID,
                  label: bal.StoreName,
                }))}
                className="w-full"
              />
            </Form.Item>
          </div>

          {/* Table Section */}
          <AddingTable
            columns={columns}
            data={subData ?? []}
            setData={setSubData}
          />

          {/* Feedback Section */}
          <Form.Item name="Notes" label="ملاحظاتك">
            <TextArea rows={4} placeholder="اكتب ملاحظاتك" />
          </Form.Item>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
